import { fetchCofidocReport } from "@/api/billing/fetchCofidocReport";
import { useSystemContext } from "@/provider/common/SystemProvider";
import { Report } from "@/types/nurse";
import { useQueryParams } from "@/utils/useQueryParams";
import { addMonths, format } from "date-fns";
import { fr } from "date-fns/locale";
import React, { useState, useEffect } from "react";

export function ReportVieWrapper({ children }) {
  const params = useQueryParams();
  const { setLoading, getUser } = useSystemContext();
  const [reports, setReports] = useState<Report[]>([]);

  // Get refunds function
  async function getFilteredReport(dateFilter: Date) {
    const user = getUser();
    const email = user?.email || null;
    const username = user?.identifiant || null;

    const report = await fetchCofidocReport({
      dateStart: dateFilter,
      dateEnd: addMonths(dateFilter, 1),
      username,
      email,
    });

    console.log("REPORT VIEW FETCH", report);


    return report?.sort((a, b) => {
      const dateA = a.date instanceof Date ? a.date : new Date(a.date);
      const dateB = b.date instanceof Date ? b.date : new Date(b.date);
      return dateA.getTime() - dateB.getTime();
    });
  }

  console.log("REPORT VIEWS", reports);


  // Get data function
  async function getData() {
    try {
      const dateFilter = params.period
        ? new Date(Number(params.period))
        : new Date();
      const initialDate = new Date(
        `${dateFilter.getMonth() + 1}/01/${dateFilter.getFullYear()}`
      );
      setLoading(true);
      const report = await getFilteredReport(initialDate);
      setReports(report);
    } catch (error) {
      console.log("error :", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.period]);

  const dateFilter = params.period ? new Date(Number(params.period)) : new Date();
  const periodLabel = format(dateFilter, "MMMM yyyy", { locale: fr });

  return <>{React.cloneElement(children, { reports, periodLabel })}</>;
}
